var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOurVision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 69,
    viewBox: "0 0 62 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.45977,
    cy: 5.19829,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6482,
    cy: 5.19829,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8367,
    cy: 5.19829,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0252,
    cy: 5.19829,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.2142,
    cy: 5.19829,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.45977,
    cy: 13.3868,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6482,
    cy: 13.3868,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8367,
    cy: 13.3868,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0252,
    cy: 13.3868,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.2142,
    cy: 13.3868,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.45977,
    cy: 21.5755,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6482,
    cy: 21.5755,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8367,
    cy: 21.5755,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0252,
    cy: 21.5755,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.2142,
    cy: 21.5755,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.45977,
    cy: 29.764,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6482,
    cy: 29.764,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8367,
    cy: 29.764,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0252,
    cy: 29.764,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.2142,
    cy: 29.764,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.45977,
    cy: 37.9524,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6482,
    cy: 37.9524,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8367,
    cy: 37.9524,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0252,
    cy: 37.9524,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.2142,
    cy: 37.9524,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.45977,
    cy: 46.1412,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6482,
    cy: 46.1412,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8367,
    cy: 46.1412,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0252,
    cy: 46.1412,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.2142,
    cy: 46.1412,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.45977,
    cy: 54.3296,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6482,
    cy: 54.3296,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8367,
    cy: 54.3296,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0252,
    cy: 54.3296,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.2142,
    cy: 54.3296,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.45977,
    cy: 62.5181,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6482,
    cy: 62.5181,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8367,
    cy: 62.5181,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0252,
    cy: 62.5181,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.2142,
    cy: 62.5181,
    r: 1.2625,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46289 47.8028L23.9267 27.3391L35.1682 38.5805L55.4027 18.3459",
    stroke: "url(#paint0_linear_740_22131)",
    strokeWidth: 6.73333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2603 12.5076L56.624 29.8103L43.9575 17.1438L61.2603 12.5076Z",
    fill: "url(#paint1_linear_740_22131)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_22131",
    x1: 15.4801,
    y1: 35.0006,
    x2: 55.0295,
    y2: 34.9838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_22131",
    x1: 49.0619,
    y1: 16.8479,
    x2: 60.2014,
    y2: 27.9821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurVision);
export default __webpack_public_path__ + "static/media/Our Vision.b073c5d19895787e176ea06a0f2ffd72.svg";
export { ForwardRef as ReactComponent };